import { useFetchEditableGroupsQuery, useFetchGroupByIdQuery } from '../groupsApi';

export const useEditableGroups = (params = {}) => {
  return useFetchEditableGroupsQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      groups: data ?? [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useGroupById = (id, params = {}) => {
  return useFetchGroupByIdQuery({ id, ...params }, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      group: data,
      isLoading,
      isError,
      error,
    }),
    skip: !id,
  });
};

export const useGroup = (id) => {
  return useGroupById(id, { withCounts: true });
};
